import React, {useMemo} from "react";
import cn from "classnames";
import styles from "./Footer.module.scss";
import FooterFeedback from "./FooterFeedback";
import {Container, Row, Col} from "react-bootstrap";
import Title from '../../components/Global/Title/Title';
import socialData from "../../data/socialData.json";

interface Props {
    id: string
}

const Footer: React.FC<Props> = ({id}) => {
    const currentYear = new Date().getFullYear();

    const social = useMemo(() => {
        return socialData.map((item, index) => {
            return (
                <Col xs={12} md={4} xl={6} key={index}>
                    <div className={styles.card}>
                        <a href={item.href} className='d-flex align-items-center d-md-block text-md-center'>
                            <img loading="lazy" src={item.img} className='img-fluid me-3 me-md-0 mb-md-3' alt=""/>
                            <p className={styles.description}>{item.description}</p>
                        </a>
                    </div>
                </Col>
            );
        });
    }, [socialData]);

    return (
        <footer id={id} className={styles.bg}>
            <img loading="lazy" src="./assets/image/ball_w.png"
                 className={cn(styles.levitatingBall, styles.levitatingBallW)} alt="Шар"/>
            <img loading="lazy" src="./assets/image/ball_w.png"
                 className={cn(styles.levitatingBall, styles.levitatingBallW2)} alt="Шар"/>
            <img loading="lazy" src="./assets/image/ball_r.png"
                 className={cn(styles.levitatingBall, styles.levitatingBallR)} alt="Шар"/>
            <img loading="lazy" src="./assets/image/ball_r.png"
                 className={cn(styles.levitatingBall, styles.levitatingBallR2)} alt="Шар"/>
            <img loading="lazy" src="./assets/image/ball_r.png"
                 className={cn(styles.levitatingBall, styles.levitatingBallR3)} alt="Шар"/>
            <div className={styles.footer}>
                <Container>
                    <Row>
                        <Col lg={8} className='mb-4 order-xl-0'>
                            <Title title='Остались вопросы?' titleShadow='Вопросы' className='white'/>
                        </Col>
                        <Col xl={7} className={cn(styles.formPadding, 'order-xl-2')}>
                            <FooterFeedback/>
                        </Col>
                        <Col xl={5} className='order-xl-3'>
                            {/*<Col xs={12}>*/}
                            <p className={styles.subtitle}>Будем на связи</p>
                            {/*</Col>*/}
                            <Row className='g-4 py-5 py-xl-0'>
                                {social}
                                <Col xs={12} md={4} xl={12}>
                                    <div className={cn(styles.card, styles.lastCard)}>
                                        <p className='text-md-center'>Вы также можете связаться с нами через:</p>
                                        <div className={styles.anotherLinks}>
                                            <div
                                                className='d-flex align-items-start text-xl-end justify-content-md-center justify-content-xl-around'>
                                                <img loading="lazy" src="./assets/Social/mail.svg"
                                                     className='img-fluid me-2 mt-1' alt=""/>
                                                <div>
                                                    <a href="mailto:info@elsgroup.ru">info@elsgroup.ru</a>
                                                    <p className={cn(styles.lastCardDescription, 'mb-xl-1')}>По любым
                                                        вопросам</p>
                                                </div>
                                            </div>
                                            <div
                                                className='d-flex align-items-start text-xl-end justify-content-md-center justify-content-xl-around'>
                                                <img loading="lazy" src="./assets/Social/phone.svg"
                                                     className='img-fluid me-1 mt-1' alt=""/>
                                                <div>
                                                    <a href="tel:88005559766">8 (800) 555 9766</a>
                                                    <p className={cn(styles.lastCardDescription, 'mb-0')}>С 9:00 до
                                                        21:00 по МСК</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} xl={4} className='pb-5 text-center text-xl-end order-xl-1'>
                            <img loading="lazy" src="./assets/icon/logo.svg" className="img-fluid" alt="ELS"/>
                        </Col>
                        <Col xs={12} className='order-xl-4'>
                            <div className={cn(styles.border, 'text-center pt-5 pb-4 mt-xl-5')}>
                                <p className='mb-2'>© «ГК ЕЛС» {currentYear}</p>
                                <p className='mb-2'>Круглосуточная поддержка экспертов.</p>
                                <p className='mb-2'>Все права защищены.</p>
                            </div>
                            <div className={styles.offerts}>
                                <a href="./assets/docx/politika.pdf?123" target='_blank'>Политика конфиденциальности</a>
                                <a href="./assets/docx/soglasie.pdf?123" target='_blank'>Согласие на обработку персональных
                                    данных</a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    )
}

export default Footer;